import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Radium, keyframes } from 'higher-order-components'
import background from './background-image.png'

/** Configured Vehicle Component. */
class ConfiguredVehicle extends Component {
  static propTypes = {
    src: PropTypes.string,
    isFadeAnimation: PropTypes.bool
  }
  constructor(props) {
    super(props)
    this.state = {
      top: props.src,
      bottom: props.src
    }
  }
  componentWillReceiveProps(newProps) {
    const { top } = this.state
    const { src } = this.props
    if (newProps.src !== src) {
      this.setState({ bottom: false, top: false }, () => {
        this.setState({ bottom: top, top: newProps.src ? newProps.src : top })
      })
    }
  }
  render() {
    const { noShadow = false } = this.props
    const { top, bottom } = this.state
    return (
      <div style={styles.base(true)} data-test="configured-vehicle">
        {top && (
          <img
            style={[styles.top, styles.proportionalSizing]}
            src={top}
            data-test="active-vehicle"
          />
        )}
        {bottom && (
          <img
            style={[styles.proportionalSizing, styles.fadeOut(this.props.isFadeAnimation)]}
            src={bottom}
          />
        )}
      </div>
    )
  }
}

export default Radium(ConfiguredVehicle)

const fadeOutKeyframes = keyframes({
  from: {
    opacity: 1
  }
})

const crossfadeDuration = '.5s'

const styles = {
  base: noShadow => ({
    alignItems: 'center',
    margin: 'auto',
    width: '100%',
    // height: '100%', // Commented because it was a reason for a bug
    position: 'relative',
    pointerEvents: 'none',
    display: 'block',
    backgroundImage: noShadow ? 'none' : `url(${background})`,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  }),
  top: {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    margin: 'auto'
  },
  fadeOut: isFadeAnimation => ({
    opacity: 0,
    animation: isFadeAnimation && `x ${crossfadeDuration} ease-in`,
    animationName: isFadeAnimation && fadeOutKeyframes
  }),
  proportionalSizing: {
    maxWidth: '100%',
    maxHeight: '100%',
    left: '0px',
    right: '0px',
    margin: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/containers/configured-vehicle/index.jsx